import { PhoneAssociationViewModel } from '@apis/model/phoneAssociation/PhoneAssociationViewModel';
import { toCaptchaViewModel, toOtpViewModel } from '@apis/responseTransformer';
import { InfoResponse, ResponseCode } from '@ul/api';

export const toPhoneAsscociationViewModel = (response: InfoResponse): PhoneAssociationViewModel => {
    const { success, responseCode } = response;
    return {
        responseCode,
        success,
        captchaViewModel: responseCode === ResponseCode.NeedCaptcha ? toCaptchaViewModel(response) : undefined,
        otpViewModel: toOtpViewModel(response),
    };
};
